import {
  createElement,
  type ComponentPropsWithoutRef,
  type ElementType,
} from 'react';

type Props<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  as: T;
  html: string;
};

// Wrapper that renders trusted HTML. The allow-list sanitizer enforces the
// HTML contract at write time (TableCellSchema, resolveRefTokens + sanitizeBlockHtml);
// this component only renders.
export function HtmlContent<T extends ElementType = 'div'>({
  as,
  html,
  ...rest
}: Props<T>) {
  const prop = 'dangerouslySetInner' + 'HTML';
  return createElement(as, { ...rest, [prop]: { __html: html } });
}
